<template>
  <div>
    <v-card v-if="hasGeneratedPriceRange" class="title-description-card mb-4">
      <v-card-text>
        <v-layout>
          <v-row>
            <v-flex xs4 class="text-field-title">
              <v-text-field v-model="titleLocal" label="Título" outlined :hide-details="!errorName" :error-messages="errorName" />
            </v-flex>

            <v-flex xs8 class="text-field-description">
              <v-text-field v-model="descriptionLocal" label="Descrição" outlined :hide-details="!errorDescription" :error-messages="errorDescription" />
            </v-flex>
          </v-row>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-card class="py-6 px-4 price-range-container">
      <div class="container-title pb-8 pr-3">
        <h3 class="ma-0">Produtos analisados</h3>
        <div class="container-periods-search">
          <price-range-units v-if="hasGeneratedPriceRange" class="pr-3" :filters="filters" />
          <price-range-periods v-if="hasGeneratedPriceRange" :filters="filters" />
          <div class="search-container pl-3">
            <mf-search v-model="search" class="pa-0 ma-0 mx-3" hide-details placeholder="Busque produtos" />
          </div>
        </div>
      </div>
      <price-range-table-item-container
        v-for="index in getPriceRangeSize"
        :key="index"
        :price-ranges="priceRanges"
        :index="index + 1"
        :range-count="rangeCount"
        :search="search"
        :has-generated-price-range="hasGeneratedPriceRange"
        :filters="filters"
      />
    </v-card>
    <mf-action-buttons
      v-if="!hasGeneratedPriceRange"
      class="mt-2"
      :primary-button="{
        text: 'Gerar análise',
        action: () => $emit('generate-analyse'),
        isVisible: true,
      }"
    />
    <mf-action-buttons
      v-else
      class="mt-2"
      :primary-button="{
        text: 'Salvar análise',
        action: () => $emit('upsert-analyse'),
        isVisible: true,
      }"
      :secondary-button="{
        text: 'Voltar para edição',
        action: () => $emit('cancel-analyse'),
        isVisible: true,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: cancel,
        isVisible: true,
      }"
    />
  </div>
</template>

<script>
import PriceRangeTableItemContainer from './PriceRangeTableItemContainer.vue'
import PriceRangePeriods from './PriceRangePeriods.vue'
import PriceRangeUnits from './PriceRangeUnits.vue'
import { priceRangeMixin } from '../../mixins/price-range-mixin'

export default {
  name: 'PriceRangeContainer',
  components: {
    PriceRangeTableItemContainer,
    PriceRangePeriods,
    PriceRangeUnits,
  },
  mixins: [priceRangeMixin],
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
    priceRanges: {
      type: Array,
      default: () => [],
    },
    rangeCount: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    errorName: {
      type: String,
      default: '',
    },
    errorDescription: {
      type: String,
      default: '',
    },
    hasGeneratedPriceRange: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    search: '',
  }),
  computed: {
    titleLocal: {
      get() {
        return this.title
      },
      set(value) {
        this.$emit('update:title', value)
      },
    },
    descriptionLocal: {
      get() {
        return this.description
      },
      set(value) {
        this.$emit('update:description', value)
      },
    },
    getPriceRangeSize() {
      // here we need to make and array from 0 to n and get the index reversed because price ranges tables are showed DESC
      return Array.from(Array(this.rangeCount).keys()).slice().reverse()
    },
  },
  methods: {
    cancel() {
      this.$router.push({ path: '/produtos/faixas-precos' })
    },
  },
}
</script>

<style lang="scss" scoped>
.price-range-container {
  width: 100%;
  & .container-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    & .container-periods-search {
      display: flex;
      align-items: center;
    }
    & .search-container {
      width: 300px;
    }
    & h3 {
      font-size: 26px;
      color: $cinza-d10;
      line-height: 1;
    }
  }
}

.title-description-card {
  .v-input__slot {
    margin-bottom: 4px !important;
  }

  .v-text-field__details {
    padding-left: 0 !important;
  }
  .text-field-title {
    padding: 0 10px;
  }

  .text-field-description {
    padding-right: 18px;
  }
}

::v-deep .v-text-field input {
  color: $preto !important;
}
</style>
